<template>
    <div class="tooltip" >
        <img src="@/assets/icons/tooltip.svg" alt="Tooltip" @mouseover="openTip" @mouseleave="closeTip">
        <div class="tip" v-if="tooltip">
            <p v-if="tip">{{tip}}</p>
            <!-- <div class="close">
                <img src="@/assets/icons/close.svg" alt="Close tip" @click="tooltip=false">
            </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'Tooltip',
    props: {
        tip: {
            type: String,
            required: true
        },
        tooltipActive:{
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            tooltip: false
        }
    },
    methods: {
        closeTip: function(){
            if (this.tooltip){
                this.tooltip = false;
            }
        },
        openTip: function(){
            if(this.tooltipActive){
                this.tooltip = true
            }    
        }

    },
}
</script>

<style lang="sass" scoped>
.tooltip
    position: absolute
    width: 16px
    height: 16px
    top: 8px
    right: 8px
    cursor: pointer
    z-index: 900

.tooltip .tip
    width: 261px
    box-shadow: 0 2px 10px 0 rgba(173, 182, 212, 0.45)
    background-color: #ffffff
    border-radius: 12px
    position: absolute
    top: -8px
    left: -266px
    z-index: 99
    cursor: default

.tooltip .tip p 
    font-family: Muli
    font-size: 12px
    font-weight: 300
    color: #302f2f
    margin-top: 8px
    margin-left: 23px
    margin-bottom: 8px
    margin-right: 12px

.tooltip .tip .close
    width: 8px
    height: 8px
    position: absolute
    top: 4px
    left: 8px
    cursor: pointer

.tooltip .tip .close img
    max-width: 100%
    max-height: 100%

.tooltip .tip::after
    content: " "
    height: 0
    width: 0
    border-top: solid 5px transparent
    border-left: solid 5px #ffffff
    border-bottom: solid 5px transparent
    border-right: solid 5px transparent
    position: absolute
    top: 12px
    right: -10px

@media (max-width: $tablet)
    .tooltip .tip p
        font-family: Muli
        font-size: 12px
        font-weight: 300
        color: #302f2f
        margin-left: 12px

    .tooltip .tip .close
        display: none
</style>